import Vue from "vue";
// import SwiperClass, { /* swiper modules... */ } from 'swiper'

import VueAwesomeSwiper from "vue-awesome-swiper";
import App from "./App.vue";
import "swiper/css/swiper.min.css"; // vue文件中用到了样式穿透，样式的引入需要写到前面
import router from "./router";

import "./styles/common.scss";
import "./styles/baseFontFamily.css";
import init from "./js/init.js";
import SwiperController from "./js/swiper_controller";

Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();
Vue.prototype.$swiperController = new SwiperController();
Vue.prototype.$global = {};

Vue.prototype._clickNavScrolling = false;
Vue.prototype._setClickNavScrolling = (flag) => {
  Vue.prototype._clickNavScrolling = flag;
};

/* eslint-disable no-new */

init();
Vue.use(VueAwesomeSwiper);
new Vue({
  el: "#app",
  router,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js